import type { DummyFoods } from './dummyFoods'

export const proteinPowder: DummyFoods = {
  'Protein powder': {
    'Brown rice': ['Brown rice protein powder'],
    Casein: ['Casein protein powder'],
    Hemp: ['Hemp protein powder'],
    Pea: ['Pea protein powder'],
    Soy: ['Soy protein powder'],
    Whey: ['Whey protein powder'],
  },
}
